export const GaugeChartColors = {
  RED: '#f97066',
  ORANGE: '#ffa67d',
  GREEN: '#bee092',
};
